import * as React from 'react'

const SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="11"
      cy="11"
      r="7"
      stroke='#3879F0'
      strokeWidth='1,5'
    />
    <path
      d="M16 16L20 20"
      stroke='#3879F0'
      strokeWidth='1,5'
      strokeLinecap="round"
    />
  </svg>
)

export default SVG
